import {
  FETCH_HEALTH_SPAN_PROFILE_REQUEST,
  FETCH_HEALTH_SPAN_PROFILE_SUCCESS,
  FETCH_HEALTH_SPAN_PROFILE_FAILURE,
  FETCH_HEALTH_SPAN_PROFILE_STATUS,
  CLEAR_HEALTH_SPAN_PROFILE,
} from './types';
import { fetchHealthSpanProfile, PROFILE_STATUS } from '../services/healthWellness/healthSpan.service';

/**
 * Fetch health span profile action
 * Handles not_found, processing, and ready statuses
 * @returns {Function} Thunk action
 */
export const fetchHealthSpanProfileAction = () => async (dispatch) => {
  dispatch({ type: FETCH_HEALTH_SPAN_PROFILE_REQUEST });

  try {
    const result = await fetchHealthSpanProfile();

    if (result.status === PROFILE_STATUS.NOT_FOUND) {
      dispatch({
        type: FETCH_HEALTH_SPAN_PROFILE_STATUS,
        payload: PROFILE_STATUS.NOT_FOUND,
      });
      return result;
    }

    if (result.status === PROFILE_STATUS.PROCESSING) {
      dispatch({
        type: FETCH_HEALTH_SPAN_PROFILE_STATUS,
        payload: PROFILE_STATUS.PROCESSING,
      });
      return result;
    }

    dispatch({
      type: FETCH_HEALTH_SPAN_PROFILE_SUCCESS,
      payload: result.profile,
    });
    return result;
  } catch (error) {
    dispatch({
      type: FETCH_HEALTH_SPAN_PROFILE_FAILURE,
      payload: error.message || 'Failed to fetch health span profile',
    });
    throw error;
  }
};

/**
 * Clear health span profile from state
 * @returns {Object} Action object
 */
export const clearHealthSpanProfile = () => ({
  type: CLEAR_HEALTH_SPAN_PROFILE,
});
